<template>
	<v-layout wrap class="journal-detail">
		<div class="content-header-mobile">
			<div class="blue-text">
				Debe: <br>
				{{ debit | round }}
			</div>
			<div class="red-text">
				Haber: <br>
				{{ credit | round }}
			</div>
			<div class="background-balance">
				Saldo: <br>
				{{ balance | round }}
			</div>
		</div>
		<v-flex xs12 mb-2 class="wrapper-detail" v-if="open">
			<div class="layout justify-center content-open">
				<span>Detalle de Asiento - Código: {{ rowSelected.code }}</span>
				<div class="ml-3 show-desktop">
					<button
						@click="toggleBtn"
						:disabled="Object.keys(rowSelected).length === 0">
						<v-icon color="success" v-if="open">arrow_drop_up</v-icon>
						<v-icon color="success" v-else>arrow_drop_down</v-icon>
					</button>
				</div>
			</div>
			<div class="pa-3" v-if="open">
				<journal-detail-table
					:row-selected="rowSelected"
					:row-detail="rowDetail"
				/>
			</div>
		</v-flex>
		<v-layout wrap v-if="openDetailSeat">
			<v-flex xs12 class="title-heading pt-1">
				Detalles
			</v-flex>
			<v-flex xs12 class="body-seat-form">
				<v-layout row wrap align-start>
					<v-flex xs8>
						<multiselect
							v-model="accountingAccount"
							:options="accounts"
							id="focus-added"
							label="fullName"
							track-by="id"
							class="filter-select-custom"
							:select-label="''"
							:limit="100"
							:selected-label="''"
							:deselect-label="''"
							placeholder="Seleccione una cuenta"
							@select="setData"
							:tabindex="modules.length === 0 || modules.length === 1 ? 3 : 4">
							<template slot="option" slot-scope="props">
								<div
									:class="{
										'item-list-disabled': settings && settings
										.stat && props.option.stat === 1 }">
									{{ props.option.fullName }}
								</div>
							</template>
						</multiselect>
						<!-- <autocomplete-component
							append-icon="expand_more"
							http-code="$http"
							id="focus-added"
							:item="accountingAccount"
							item-text="fullName"
							item-value="id"
							:items="accounts"
							autocomplete
							model="accountingAccount"
							placeholder-value="Buscar cuenta contable"
							placeholder-input="Nombre de la cuenta"
							prop="account"
							prop-search="fullName"
							:readonly-prop="accountingAccount.name"
							readonly-prop-show
							:resource-url="`accounting-plan/${params.subsidiaryId}/subsidiary?status=1`"
							return-object
							select-create
							:tabindex="modules.length === 0 || modules.length === 1 ? 3 : 4"
							@return-data="setData"
						></autocomplete-component> -->
					</v-flex>
					<v-flex xs4 pl-2>
						<app-input-text
							model="reference"
							placeholder="Referencia"
							:tabindex="modules.length === 0 || modules.length === 1 ? 4 : 5"
							:text="modelDetail.reference"
							@input="$emit('set-model-data', $event)"
						></app-input-text>
					</v-flex>
					<v-flex xs4 pr-2>
						<app-input-text
							model="concept"
							placeholder="Concepto"
							:tabindex="modules.length === 0 || modules.length === 1 ? 5 : 6"
							:text="modelDetail.concept"
							@input="$emit('set-model-data', $event)"
						></app-input-text>
					</v-flex>
					<v-flex xs4>
						xxxxx
						<autocomplete-component
							append-icon="expand_more"
							http-code="$http"
							:item="modelDetail.costCenterId"
							item-text="name"
							item-value="id"
							:items="costCenters"
							model="costCenterId"
							placeholder-value="Centro de costos"
							prop="name"
							prop-search="name"
							:resource-url="`cost-center/${params.subsidiaryId}/subsidiary`"
							return-object
							select-create
							:tabindex="modules.length === 0 || modules.length === 1 ? 6 : 7"
							@return-data="setCostCenter"
						></autocomplete-component>
					</v-flex>
					<v-flex xs3 pl-2>
						<app-input-text
							model="amount"
							placeholder="Importe"
							:tabindex="modules.length === 0 || modules.length === 1 ? 7 : 8"
							:text="modelDetail.amount"
							tooltip-message="Ingresar el importe con signo negativo (-) para crear detalles de tipo HABER"
							tooltip-on-focused
							type="number"
							@input="$emit('set-model-data', $event)"
						></app-input-text>
						<span
							v-if="modelDetail.amount !== 0"
							:class="`${modelDetail.amount < 0 ? 'error' : 'secondary'}--text caption`">
							Detalle de tipo {{ typeDetail }}
						</span>
					</v-flex>
					<v-flex xs1 text-xs-center pt-2>
						<button
							class="btn-create-seat"
							:tabindex="modules.length === 0 || modules.length === 1 ? 8 : 9"
							type="button"
							@click="$emit('add-detail')"
						>
							<v-icon color="secondary" size="26">add_circle</v-icon>
						</button>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-flex xs12 class="table-scroll">
			<journal-detail-list-add
				:flag-edit-inline="flagEditInline"
				:accounts="accounts"
				:code-journal="codeJournal"
				:cost-centers="costCenters"
				:edit-detail-inline="editDetailInline"
				:rows="details"
				:flagSquareSeats="flagSquareSeats"
				:created-add="createdAdd"
				:subsidiary-id="subsidiaryId"
				:settings="settings"
				@columns-Visible="$emit('columns-Visible')"
				@add-icon="$emit('add-icon', $event)"
				@edit-detail-inline="$emit('edit-detail-inline', $event)"
				@get-data="$emit('get-data', $event)"
				@on-search="$emit('on-search', $event)"
				@on-click="$emit('on-click', $event)"
				@click-icon="$emit('click-icon', $event)"
				@remove-item="$emit('remove-item', $event)"
				@change-amount="$emit('change-amount', $event)"
				@detail-seat="$emit('detail-seat', $event)"
				@create-action="$emit('create-action', $event)"
				@add-detail="$emit('add-detail-seat')"
				@import-excel="$emit('import-excel', $event)"
				@download-format="$emit('download-format', $event)"
			/>
		</v-flex>
		<v-flex xs12>
			<v-flex pt-1 :class="showSeatForm ? 'xs10' : 'xs1'">
				<journal-detail-balance
					:balance="balance"
					:credit="credit"
					:debit="debit"
					:to-declare="toDeclare"
					:not-declare="notDeclare"
				/>
			</v-flex>
		</v-flex>
		<v-flex xs12 style="margin-top: 5px">
			<v-layout row wrap v-if="showSeatForm">
				<v-flex xs6 pr-1 text-xs-right>
					<button
						style="width: 127px;"
						class="btn-seat btn-clean"
						:disabled="disabledFormClean"
						type="button"
						@click="$emit('clean-all')"
					>
						Vaciar Campos
					</button>
				</v-flex>
				<v-flex xs6 pl-1 text-xs-left>
					<button
						style="width: 127px;"
						class="btn-seat btn-save"
						:disabled="disabledFormSave || validButton"
						type="button"
						@click="dialog = true"
					>
						Guardar
					</button>
				</v-flex>
			</v-layout>
		</v-flex>
			<v-dialog
			v-model="dialog"
			max-width="430"
			:persistent="saving">
			<v-card class="js-dialog">
				<div
					class="js-dialog__top"
					:class="cuadrado ? 'js-dialog__top--ok' : 'js-dialog__top--warn'">
					<span class="js-dialog__icon">
						<v-icon>{{ cuadrado ? 'check_circle_outline' : 'warning' }}</v-icon>
					</span>
				</div>

				<h3 class="js-dialog__title">
					{{ cuadrado ? '¿Guardar el asiento?' : 'El asiento no está cuadrado' }}
				</h3>

				<p v-if="cuadrado" class="js-dialog__text">
					Se registrarán {{ details.length }} detalles. Podrás editarlo después desde el listado.
				</p>
				<p v-else class="js-dialog__text">
					Hay una diferencia entre el debe y el haber. Puedes guardarlo igual,
					pero el asiento quedará descuadrado.
				</p>

				<div class="js-resumen">
					<div class="js-dato">
						<span>Debe</span>
						<strong>{{ debit | round }}</strong>
					</div>
					<div class="js-dato">
						<span>Haber</span>
						<strong>{{ credit | round }}</strong>
					</div>
					<div class="js-dato js-dato--saldo" :class="{ 'js-dato--mal': !cuadrado }">
						<span>Saldo</span>
						<strong>{{ balance | round }}</strong>
					</div>
				</div>

				<div class="js-acciones">
					<button
						type="button"
						class="js-btn js-btn--ghost"
						:disabled="saving"
						@click="closeDialog">
						Cancelar
					</button>
					<button
						type="button"
						class="js-btn js-btn--main"
						:class="{ 'js-btn--warn': !cuadrado }"
						:disabled="saving"
						@click="confirmSave">
						<v-progress-circular
							v-if="saving"
							indeterminate
							size="15"
							width="2"
							color="white"
							class="mr-2" />
						{{ saving ? 'Guardando...' : 'Sí, guardar' }}
					</button>
				</div>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
	import appDateMask from '@/components/shared/app-date-mask';
	import appInputText from '@/components/autocomplete/app-input-text';
	import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
	import journalDetailBalance from '@/components/journal/journal-detail-balance';
	import journalDetailList from '@/components/journal/journal-detail-list';
	import journalDetailTable from '@/components/journal/journal-detail-table';
	import journalDetailListAdd from '@/components/journal/journal-detail-list-add';

	function created() {
		this.$emit('change-amount');
	}
	function toggleBtn() {
		this.open = !this.open;
	}

	function rowSelected(value) {
		this.open = Object.keys(value).length;
	}

	function setData(value) {
		this.$emit('set-data-account', value);
	}

	function setCostCenter(value) {
		this.$emit('set-cost-center', value);
	}

	function typeDetail() {
		return this.modelDetail.amount < 0 ? 'HABER' : 'DEBE';
	}
	function cuadrado() {
		return Number(this.balance) === 0;
	}

	function confirmSave() {
		if (this.saving) {
			return;
		}
		this.saving = true;
		this.$emit('save-all', () => {
			this.saving = false;
			this.dialog = false;
		});
	}

	function closeDialog() {
		if (this.saving) {
			return;
		}
		this.dialog = false;
		this.dialogMessage = '';
	}

	function data() {
		return {
			open: false,
			dialog: false,
			dialogMessage: '',
			saving: false,
		};
	}

	export default {
		name: 'journail-detail-add',
		data,
		created,
		components: {
			appDateMask,
			appInputText,
			autocompleteComponent,
			journalDetailBalance,
			journalDetailList,
			journalDetailTable,
			journalDetailListAdd,
		},
		methods: {
			toggleBtn,
			setData,
			setCostCenter,
			closeDialog,
			confirmSave,
		},
		computed: {
			typeDetail,
			cuadrado,
		},
		props: {
			accounts: {
				default: () => [],
				type: Array,
			},
			flagEditInline: {
				default: false,
				type: Boolean,
			},
			balance: Number,
			credit: Number,
			costCenters: {
				default: () => [],
				type: Array,
			},
			debit: Number,
			debitTotal: Number,
			details: {
				default: () => [],
				type: Array,
			},
			disabledFormClean: {
				default: false,
				type: Boolean,
			},
			disabledFormSave: {
				default: false,
				type: Boolean,
			},
			editDetailInline: {
				default: false,
				type: Boolean,
			},
			toDeclare: {
				type: Boolean,
				default: false,
			},
			notDeclare: {
				type: Boolean,
				default: false,
			},
			openDetailSeat: {
				type: Boolean,
				default: false,
			},
			codeJournal: String,
			rowSelected: {
				default: () => {},
				type: Object,
			},
			rowDetail: {
				default: () => {},
				type: Object,
			},
			showSeatForm: {
				default: false,
				type: Boolean,
			},
			subsidiaryId: [Number, String],
			accountingAccount: {
				default: () => {},
				type: Object,
			},
			modules: {
				default: () => [],
				type: Array,
			},
			modelDetail: {
				default: () => {},
				type: Object,
			},
			createdAdd: {
				type: Boolean,
				default: true,
			},
			flagSquareSeats: {
				type: Boolean,
				default: false,
			},
			validButton: {
				default: false,
				type: Boolean,
			},
			settings: {
				type: Object,
				default: () => {},
			},
		},
		watch: {
			rowSelected,
		},
	};
</script>

<style lang="scss" scoped>
.journal-detail {
	float: left;
}
.content-header-mobile {
	background-color: #eceff1;
	display: flex;
	justify-content: space-between;
	width: 100%;
}

.blue-text {
	color: #006edb;
	font-family: map-get($fonts, AvenirDemi);
	font-size: 12px;
	padding-left: 19px;
}

.red-text {
	color: #ff0000;
	font-family: map-get($fonts, AvenirDemi);
	font-size: 12px;
}

.background-balance {
	background-color: #a9bac2;
	color: white;
	font-family: map-get($fonts, AvenirBold);
	font-size: 12px;
	padding-top: 6px;
	text-align: center;
	width: 102px;
}

.content-header-mobile {
	display: none;

	@media (max-width: 768px) {
		display: flex;
	}
}

.content-open {
	background-color: #e0e5e8;
	font-weight: 700;
	padding: 5px 0;
}

.wrapper-detail {
	@media (max-width: 768px) {
		display: none;
	}
}

.btn-seat {
	color: white;
    border-radius: 10px;
    font-family: 'AvenirRegular';
    font-size: 14px;
	padding: 5px 15px;

	&[disabled] {
		opacity: 0.5;
	}

	&.btn-save {
		background-color: #02979b;
	}

	&.btn-clean {
		background-color: color(error);
	}
}
.table-scroll {
  max-height: 230px;
  overflow-y: auto;
}

.title-heading {
	background-color: #e0e5e8;
	color: color(black);
	font-family: font(AvenirBold);
	font-size: size(medium);
	height: 25px;
	text-align: center;
}

.show-desktop {
	@media (min-width: 1024px) {
		display: none;
	}
}
.js-dialog {
	border-radius: 16px !important;
	overflow: hidden;
	padding: 0 24px 20px;
	text-align: center;
}

.js-dialog__top {
	margin: 0 -24px 16px;
	padding: 22px 0 16px;
}

.js-dialog__top--ok {
	background: linear-gradient(135deg, rgba(2, 151, 155, 0.12), rgba(2, 151, 155, 0.04));
}

.js-dialog__top--warn {
	background: linear-gradient(135deg, rgba(245, 158, 11, 0.16), rgba(245, 158, 11, 0.05));
}

.js-dialog__icon {
	align-items: center;
	background: #ffffff;
	border-radius: 50%;
	box-shadow: 0 4px 14px rgba(15, 42, 68, 0.12);
	display: inline-flex;
	height: 56px;
	justify-content: center;
	width: 56px;

	.v-icon {
		font-size: 28px !important;
	}
}

.js-dialog__top--ok .js-dialog__icon .v-icon {
	color: #02979b !important;
}

.js-dialog__top--warn .js-dialog__icon .v-icon {
	color: #d97706 !important;
}

.js-dialog__title {
	color: #16222b;
	font-size: 18px;
	font-weight: 700;
	line-height: 1.3;
	margin: 0 0 8px;
}

.js-dialog__text {
	color: #64748b;
	font-size: 13px;
	line-height: 1.55;
	margin: 0 auto 18px;
	max-width: 330px;
}

.js-resumen {
	border: 1px solid #e3e9ec;
	border-radius: 12px;
	display: flex;
	margin-bottom: 20px;
	overflow: hidden;
}

.js-dato {
	flex: 1 1 0;
	padding: 10px 6px;

	& + & {
		border-left: 1px solid #e3e9ec;
	}

	span {
		color: #90a0aa;
		display: block;
		font-size: 9.5px;
		font-weight: 700;
		letter-spacing: 0.9px;
		text-transform: uppercase;
	}

	strong {
		color: #16222b;
		display: block;
		font-size: 15px;
		font-variant-numeric: tabular-nums;
		margin-top: 2px;
	}
}

.js-dato--saldo {
	background: rgba(2, 151, 155, 0.06);

	strong {
		color: #02979b;
	}
}

.js-dato--mal {
	background: rgba(229, 72, 77, 0.07);

	strong {
		color: #e5484d;
	}
}

.js-acciones {
	display: flex;
	gap: 10px;
}

.js-btn {
	align-items: center;
	border-radius: 10px;
	display: inline-flex;
	flex: 1 1 0;
	font-size: 13px;
	font-weight: 700;
	height: 40px;
	justify-content: center;
	transition: background-color 0.18s ease, opacity 0.18s ease;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.65;
	}
}

.js-btn--ghost {
	background: #ffffff;
	border: 1px solid #e3e9ec;
	color: #5b6b76;

	&:hover:not(:disabled) {
		background: #f4f7f8;
	}
}

.js-btn--main {
	background: #02979b;
	color: #ffffff;

	&:hover:not(:disabled) {
		background: #017e82;
	}
}

.js-btn--warn {
	background: #d97706;

	&:hover:not(:disabled) {
		background: #b45309;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/journal/journal-detail-add.vue